<template>
  <div class="_header">
    <div class="header_center thewidth_center2 jc_flex">

      <div class="__logo">
        <a href="/">
          <img src="@/assets/images/logo.png" alt="Logo" class="logo_icon" />
          <span class="logo_title">Crygrp</span>
        </a>
      </div>

      <div class="__menu jc_flex_1">
        <el-menu 
          :default-active="activeIndex" 
          mode="horizontal" 
          router>
          <el-menu-item index="/">Home</el-menu-item>
          <el-submenu index="/Dataset" class="__submenu">
            <template slot="title">
              <span style="color: #333;">Group-theory-based Datasets</span>
            </template>
            <el-menu-item index="/Dataset/Magnetic">Magnetic space group</el-menu-item>
            <!-- <el-menu-item index="/Dataset/Spin">Spin space group</el-menu-item> -->
            <el-submenu index="/Dataset/Spin" class="__submenu">
              <template slot="title">
                <span style="color: #333;">Spin space group</span>
              </template>
              <el-menu-item index="/Dataset/Spin/Collinear">Collinear spin space group</el-menu-item>
              <el-menu-item index="" disabled>Coplanar spin space group</el-menu-item>
              <el-menu-item index="" disabled>Non-coplanar spin space group</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item index="" disabled>Materials-based Datasets</el-menu-item>
          <el-menu-item index="/Codes">Source Codes</el-menu-item>
          <el-menu-item index="/Programs">Programs</el-menu-item>
          <el-menu-item index="/Models" disabled>Large Language Models</el-menu-item>
          <el-menu-item index="/Papers">Published Papers</el-menu-item>
        </el-menu>
      </div>

      <!-- <div class="__admin">
        <el-tooltip class="item" effect="dark" content="Crygrp Manager" placement="bottom">
          <a href="/Admin/Home" target="_blank">
            <i class="iconfont icon-guanli"></i>
          </a>
        </el-tooltip>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    activeIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
};
</script>

<style scoped>
._header {
  background-color: rgb(255 255 255 / .5);
  border-bottom: 1px rgba(#EFEFEF,0.6) solid;
  box-shadow: 0 1px 3px 0px rgba(10,10,10,0.06);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1999;
}
.header_center{
  padding: 0 20px;
  .__logo{
    a{
      display: block;
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: rgb(2, 84, 236) !important;
      text-transform: uppercase;
      padding: 10px 0;
      margin-right: 100px;
      .logo_icon{
        width: 30px;
        height: 30px;
        margin-right: 5px;
        vertical-align: middle;
      }
    }
  }
  .__menu{
    font-size: 14px !important;
    .el-menu--horizontal.el-menu{
      color: #333 !important;
      border-bottom: none !important;
      background: none !important;
      font-weight: 600 !important;
      /* text-transform: uppercase !important; */
      .el-menu-item{
        color: #333 !important;
        background: none !important;
        font-weight: 600 !important;
        &:hover{
          color: rgb(2, 84, 236) !important;
          background: none !important;
        }
        &.is-active{
          color: rgb(2, 84, 236) !important;
          background: none !important;
          border-bottom: none !important;
        }
      }
      .el-submenu.__submenu{
        &.is-opened{
          .el-submenu__title{
            color: rgb(2, 84, 236) !important;
            background: none !important;
            font-weight: 600 !important;
            border-bottom: none !important;
          }
        }
        .el-submenu__title{
          color: #333 !important;
          background: none !important;
          font-weight: 600 !important;
          border-bottom: none !important;
          &:hover{
            color: rgb(2, 84, 236) !important;
            background: none !important;
          }
        }
      }
    }
  }
  .__admin{
    a{
      display: block;
      font-size: 20px;
      line-height: 40px;
      color: #333;
      padding: 10px 0;
      margin-left: 100px;
      .iconfont{
        font-size: 26px;
      }
    }
  }
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border-bottom: 2px solid rgb(2, 84, 236) !important;
}
</style>